<template>
  <v-card>
    <v-card-title>
      <span>
        <v-icon>mdi-format-title</v-icon> Titolo
      </span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-text-field
        outlined
        label="Titolo"
        v-model="newArticle.title"
      ></v-text-field>
    </v-card-text>
  </v-card>
</template>
<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'ArticleTitle',
    data() {
      return {
        title: '',
      }
    },
    computed: {
      ...mapGetters([
        'newArticle'
      ])
    },
    watch: {
      title(val) {
        this.$store.commit('SET_ARTICLE_TITLE', val)
      },
      newArticle: {
        handler(val) {
          this.title = val.title
        },
        deep: true
      }
    },
    mounted() {
      this.title = this.newArticle.title
    }
  }
</script>